module.exports = __webpack_public_path__ + "static-portal/img/50-1.f01bd51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/50-1.jpg
// module id = w3AX
// module chunks = 4